<template>

    <nav
        :aria-label="lang('dataset.overview.aria-label')"
    >
        <ul class="pagination justify-content-center">
            <li
                v-if="links.first !== null && meta.current_page > 1"
                class="page-item"
            >
                <inertia-link
                    class="switcher"
                    :href="links.first"
                    v-tooltip="lang('global.first')"
                >
                    <span class="sr-only">{{ lang('global.first') }}</span>
                    <i class="mdi mdi-page-first"></i>
                </inertia-link>
            </li>

            <li
                v-if="links.prev !== null"
                class="page-item"
            >
                <inertia-link
                    class="switcher"
                    :href="links.prev"
                    v-tooltip="lang('global.previous')"
                >
                    <span class="sr-only">{{ lang('global.previous') }}</span>
                    <i class="mdi mdi-chevron-left"></i>
                </inertia-link>
            </li>

            <li
                v-if="hasLowerNumberedPages"
                class="spacer"
            >
                ...
            </li>

            <li
                v-for="pagenr in pages"
                :class="{'page-item':true,'active':meta.current_page === pagenr}"
            >
                <inertia-link
                    :href="meta.path + '?page=' + pagenr"
                    class="page-link"
                >
                    {{ pagenr }}
                </inertia-link>
            </li>

            <li
                v-if="hasHigherNumberedPages"
                class="spacer"
            >
                ...
            </li>

            <li
                v-if="links.next !== null"
                class="page-item"
            >
                <inertia-link
                    class="switcher"
                    :href="links.next"
                    v-tooltip="lang('global.next')"
                >
                    <span class="sr-only">{{ lang('global.next') }}</span>
                    <i class="mdi mdi-chevron-right"></i>
                </inertia-link>
            </li>

            <li
                v-if="links.last !== null && meta.current_page < meta.last_page"
                class="page-item"
            >
                <inertia-link
                    class="switcher"
                    :href="links.last"
                    v-tooltip="lang('global.last')"
                >
                    <span class="sr-only">{{ lang('global.last') }}</span>
                    <i class="mdi mdi-page-last"></i>
                </inertia-link>
            </li>
        </ul>
    </nav>

</template>

<script>

export default {
    computed: {
        hasLowerNumberedPages() {
            return this.pages[0] > 1;
        },

        hasHigherNumberedPages() {
            return this.pages[this.pages.length - 1] < this.meta.last_page;
        },

        pages() {
            let offsetPages = 1 + (2 * this.offset);

            let start = 1;

            if ((this.meta.current_page - this.offset) > 1) {
                start = this.meta.current_page - this.offset;
            }

            if (this.meta.current_page >= (this.meta.last_page - this.offset)) {
                start = this.meta.last_page - offsetPages + 1;
            }

            if (start < 1) {
                start = 1;
            }

            let end = ((start - 1) + offsetPages) > this.meta.last_page ?
                this.meta.last_page :
                ((start - 1) + offsetPages);

            let pages = [];

            for (let i = start; i <= end; i++) {
                pages.push(i);
            }

            return pages;
        },
    },

    data() {
        return {
            offset: 3,
        }
    },

    name: 'Pagination',

    props: {
        links: {
            required: true,
            type: Object,
        },
        meta: {
            required: true,
            type: Object,
        },
    },
}

</script>
